import type { ButtonProps } from '@gurupay/gp-ui-library';
import { DropdownButton } from '@gurupay/gp-ui-library';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

export const NewPaymentButton: FC<ButtonProps & { openDirection: 'top' | 'bottom' }> = ({
	type = 'button',
	variant = 'primary-black',
	icon,
	className,
	children,
	openDirection,
}) => {
	const { t } = useTranslation('', { keyPrefix: 'paymentsPage' });
	const isMobile = useMediaQuery({ query: '(max-width: 480px)' });

	const buttonOptions = [
		{ label: t('sepa'), link: '/payments/sepa' },
		{ label: t('international'), link: '/payments/international' },
		{ label: t('fx'), link: '/payments/fx' },
		...(isMobile
			? []
			: [
					{
						label: t('batch'),
						link: '/payments/batch',
					},
				]),
		{ label: t('templatesItem'), link: '/templates' },
	];

	return (
		<DropdownButton
			buttonProps={{
				type,
				variant,
				icon,
				className,
			}}
			openDirection={openDirection}
			options={buttonOptions}
		>
			{children}
		</DropdownButton>
	);
};
